import React, { useEffect } from "react";

import { useGetOrganizationSummary } from "@src/api/organization-summaries/get-organization-summary";
import { useGetOrg } from "@src/api/organizations/get-organization";
import { useGetScriptStatus } from "@src/api/shops/get-script-status";
import { useIsAdmin } from "@src/api/user-auths/is-admin";
import { useLoggedInUser } from "@src/api/user-auths/login";
import { useCheckSubscriptionStatus } from "@src/components/LimitAccess/check-subscriptions-hooks";
import { useInstallConversion } from "@src/hooks/useInstallConversion";
import { useMixpanelLogin } from "@src/hooks/mixpanel";

import { SubscribedRoutes } from "./subscribedRoutes";

export const LoggedInRoutes = () => {
  const user = useLoggedInUser();
  useGetOrganizationSummary();
  const org = useGetOrg();
  useMixpanelLogin();
  useInstallConversion(org?.data?.org);

  useIsAdmin();
  useCheckSubscriptionStatus(true);

  // Prefetch script status early for ConnectToShopifyDialog and onboarding checklist
  useGetScriptStatus(org?.data?.org?.id);

  useEffect(() => {
    if (user.isSuccess) {
      window["user"] = user?.data?.user?.firstName;
    }
  }, [user.isSuccess]);

  return <SubscribedRoutes />;
};
